import { Component } from 'preact';
import s from './style.css';
import Container from 'components/Container';

const related = [
	{
		name: 'The World of Work Spouses',
		desc: 'We all have that one colleague who makes work more bearable.',
		image: 'assets/the-world-of-work-spouses.svg',
		url: 'https://www.totaljobs.com/insidejob/work-spouse/'
	},
	{
		name: 'Superflexibility',
		desc:
			'How the modern workforce is changing the rules of work-life balance.',
		image: 'assets/superflexability.jpg',
		url: 'https://www.totaljobs.com/insidejob/work-life-balance/'
	}
];

const RelatedContent = ({ loaded }) => (
	<div className={s.root}>
		<Container>
			<h2 className={s.title}>Keep exploring your&nbsp;work-self</h2>
			<div className={s.related}>
				{related.map(({ name, desc, image, url }) => (
					<a href={url} target={'_blank'} rel="noopener" className={s.article}>
						<span
							className={s.image}
							style={{
								backgroundImage: loaded ? `url(${image})` : 'none'
							}}
						/>
						<h3 className={s.name}>
							<span>{name}</span>
						</h3>
						<p classNAme={s.desc}>{desc}</p>
					</a>
				))}
			</div>
		</Container>
	</div>
);

export default RelatedContent;



// WEBPACK FOOTER //
// ./components/RelatedContent/index.js